import { logger } from '@core/utils/logger';
import { webSocketFactory } from '@core/websocket';

type TokenGetter = () => string | Promise<string>;

let tokenGetter: TokenGetter | null = null;

const wsUrl = (): string => {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}/slab/ws`;
};

export function initSlabSocket(getToken: TokenGetter): void {
  if (tokenGetter === null) {
    tokenGetter = getToken;
  }
}

export const useSlabSocket = webSocketFactory({
  url: wsUrl(),
  getToken: () => {
    if (tokenGetter === null) {
      return Promise.reject(
        new Error('[SlabSocket] not initialized — call initSlabSocket() first'),
      );
    }
    return tokenGetter();
  },
  onConnectionError: (err) => logger.error('[SlabSocket]', err),
});
